import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { useLocalization } from '@contexts/LocalizationContext'
// import { Input } from 'antd'
import { Button, Input, Form } from 'antd'
import {
  validationSchema,
  validationSchemaEditNameShop,
  validationSchemaEditPassword,
} from './validationSchema'

const FormComponent = ({ handleSubmit, defaultValues = {}, doStatus }) => {
  const [form] = Form.useForm()

  const { t } = useLocalization()

  const tailLayout = {
    wrapperCol: {
      span: 20,
      offset: 2,
    },
  }

  const style = {
    inputShop: { width: '100%', height: '40px' },

    divBtn: {
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    btnStyleSummit: {
      height: '37px',
      width: '176px',
      borderRadius: '8px',
      border: '1px solid #56B9C3',
    },
    btnStyleCancel: {
      height: '37px',
      width: '176px',
      borderRadius: '8px',
      border: '1px solid #56B9C3',
      color: '#56B9C3',
    },
  }

  const [validationSchemaData, setvalidationSchemaData] = useState()

  useEffect(() => {
    form.resetFields()
  }, [defaultValues])

  const yupSync = {
    async validator({ field }, value) {
      try {
        await validationSchemaData.validateSyncAt(field, { [field]: value })
      } catch (error) {
        console.log(error)
        throw error
      }
    },
  }

  useEffect(() => {
    if (doStatus === 'create') {
      setvalidationSchemaData(validationSchema(t))
    } else if (doStatus === 'editNameShop') {
      setvalidationSchemaData(validationSchemaEditNameShop(t))
    } else if (doStatus === 'editPassword') {
      return validationSchemaEditPassword(t)
    }
  }, [doStatus])

  return (
    // <Form
    //   defaultValues={defaultValues}
    //   onSubmit={handleSubmit}
    //   validationSchema={validationSchemaData}
    // >

    <Form
      layout="vertical"
      form={form}
      name="control-hooks"
      onFinish={handleSubmit}
      initialValues={defaultValues}
      requiredMark={false}
    >
      <div hidden>
        <Form.Item name="id">
          {/* ฝาก Id ไปกับ Form เนื่องจากเป็น modal ฝากไปกับ path ไม่ได้ */}
          <Input />
        </Form.Item>
      </div>

      {(doStatus === 'create' || doStatus === 'editNameShop') && (
        <Form.Item
          name="name"
          label={t('rewards.shop.form.shopName')}
          defaultValue={defaultValues.ShopName || ''}
          rules={[yupSync]}
        >
          <Input style={style.inputShop} />
        </Form.Item>
      )}
      {doStatus === 'create' && (
        <Form.Item
          name="username"
          label={t('rewards.shop.form.userID')}
          defaultValue={defaultValues.userID || ''}
          rules={[yupSync]}
        >
          <Input style={style.inputShop} />
        </Form.Item>
      )}

      {(doStatus === 'create' || doStatus === 'editPassword') && (
        <div>
          <Form.Item
            name="password"
            type="password"
            label={t('rewards.shop.form.password')}
            defaultValue={defaultValues.password || ''}
            rules={[yupSync]}
          >
            <Input style={style.inputShop} />
          </Form.Item>
        </div>
      )}

      {/* เเสดงปุ่ม */}
      <Form.Item {...tailLayout}>
        <div style={{ textAlign: 'center' }}>
          {doStatus === 'create' ? (
            <Button
              type="primary"
              htmlType="submit"
              style={style.btnStyleSummitAdd}
            >
              {t('rewards.shop.form.addData')}
            </Button>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
              <Button htmlType="button" style={style.btnStyleCancel}>
                {t('rewards.shop.form.cancel')}
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                style={style.btnStyleSummit}
              >
                {t('rewards.shop.form.confirm')}
              </Button>
            </div>
          )}
        </div>
      </Form.Item>
    </Form>
  )
}
FormComponent.propTypes = {
  doStatus: PropTypes.string,
  handleSubmit: PropTypes.func,
  defaultValues: PropTypes.object,
}

export default FormComponent
